var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md:pt-0"},[_c('top-header'),_c('container')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }